import React, { useState } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { Heading, Instructions, Message, WrappedText, ExternalLinkBlock } from '../s'
import Paragraph from 'components/typography/paragraph'
import Link from 'components/link'
import { Ghost } from 'components/button'
import { Scrollable as Modal } from 'modals/generic'
import ExportUsers from 'pages/people/modals/export-users'
import { DownloadCloud as Export } from 'styled-icons/feather'

const AltinnRequiresExternalSetupInformation = ({ name, data, salt }) => {
    const { formatMessage } = useIntl()

    const [exporting, setExporting] = useState(false)

    return (
        <>
            <Heading>
                <FormattedMessage
                    id="integration_heading_connect_to_service"
                    defaultMessage="Connect to {service}"
                    values={{ service: name }} />
            </Heading>
            <Instructions
                className="hanging naked"
                instructions={[
                    {
                        content: (
                            <Paragraph className="compact">
                                <FormattedMessage
                                    id="integration_altinn_instruction_login"
                                    defaultMessage="<link>Log in to Altinn</link> with a user who has access to the organization that will receive sick leave reports."
                                    values={{
                                        link: chunks => (
                                            <Link
                                                href={data.website}
                                                target="_blank"
                                                className="constructive">
                                                {chunks}
                                            </Link>
                                        )
                                    }} />
                            </Paragraph>
                        )
                    },
                    {
                        content: (
                            <Paragraph className="compact">
                                <FormattedMessage
                                    id="integration_altinn_instruction_access"
                                    defaultMessage="Give Huma access to your organization’s sick leave messages in Altinn." />
                            </Paragraph>
                        )
                    },
                    {
                        content: (
                            <Paragraph className="compact">
                                <FormattedMessage
                                    id="integration_altinn_instruction_submit"
                                    defaultMessage="Submit the organization number for your sub organization in Altinn. For security reasons, we need to validate your organization number before the integration is activated. You will be notified when it’s done." />
                            </Paragraph>
                        )
                    }
                ]} />
            <Message
                type="info"
                message={formatMessage({
                    id: 'integration_altinn_message_valid_id',
                    defaultMessage: 'Note that sick leaves can only be created for users with a valid Norwegian identification number.'
                })} />
            <WrappedText>
                <Paragraph>
                    <FormattedMessage
                        id="integration_altinn_message_export"
                        defaultMessage="Export all user data to find employees that are missing a Norwegian identification number." />
                </Paragraph>
                <Ghost
                    onClick={() => setExporting(true)}
                    className="constructive"
                    icon={Export}>
                    <FormattedMessage
                        id="action_export_all_users"
                        defaultMessage="Export all users" />
                </Ghost>
            </WrappedText>
            <ExternalLinkBlock href={data.knowledgebaseUrl}>
                <FormattedMessage
                    id="integration_altinn_link_knowledgebase"
                    defaultMessage="Using the Altinn / NAV integration" />
            </ExternalLinkBlock>
            <Modal
                show={exporting}
                dismiss={() => setExporting(false)}
                salt={salt}>
                <ExportUsers
                    onDone={() => setExporting(false)}
                    salt={salt} />
            </Modal>
        </>
    )
}

export default AltinnRequiresExternalSetupInformation